var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMyNdw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "148px",
    height: "50px",
    viewBox: "0 0 148 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0400727273 0.224469072 59.8254545 0.224469072 59.8254545 34.9845206 0.0400727273 34.9845206"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.25875 0.280437956 34.6791071 0.280437956 34.6791071 50 0.25875 50"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONCEPT_extra_info",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tegel_extra_info",
    transform: "translate(-121.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(121.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(88.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5175273,0.224469072 L49.5175273,17.5967371 C49.5175273,21.5510155 46.2869818,24.7565825 42.3018909,24.7565825 C38.3168,24.7565825 35.0862545,21.5510155 35.0862545,17.5967371 L35.0862545,17.5512732 L35.0862545,0.224469072 L24.7789818,0.224469072 L24.7789818,17.4928196 L24.7789818,17.5512732 C24.7789818,21.5055515 21.5484364,24.7111186 17.5633455,24.7111186 C13.5782545,24.7111186 10.3477091,21.5055515 10.3477091,17.5512732 L10.3477091,0.224469072 L0.0400727273,0.224469072 L0.0400727273,17.4469948 C0.0400727273,27.0499845 7.88552727,34.9390567 17.5633455,34.9390567 C22.3931636,34.9390567 26.7666182,32.9996237 29.9357091,29.8636959 C33.1051636,33.0219948 37.4753455,34.9845206 42.3018909,34.9845206 C51.9797091,34.9845206 59.8255273,27.1997268 59.8255273,17.5967371 L59.8255273,0.224469072 L49.5175273,0.224469072 Z",
    id: "Fill-1",
    fill: "#332E20",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(46.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4691071,39.6545255 C13.5551786,39.6545255 10.3823214,36.4121898 10.3823214,32.4129197 C10.3823214,28.4132847 13.5551786,25.1709489 17.4691071,25.1709489 C21.3830357,25.1709489 24.5558929,28.4132847 24.5558929,32.4129197 C24.5558929,36.4121898 21.3830357,39.6545255 17.4691071,39.6545255 L17.4691071,39.6545255 Z M24.6001786,16.4074453 C22.4269643,15.3943066 20.01375,14.8256934 17.4691071,14.8256934 C7.96410714,14.8256934 0.25875,22.8052555 0.25875,32.5180292 C0.25875,42.2315328 7.96410714,50.000146 17.4691071,50.000146 C26.9394643,50.000146 34.6208929,42.1826277 34.6769643,32.5180292 L34.6791071,32.5180292 L34.6791071,0.280437956 L24.6448214,0.280437956 L24.6001786,16.4074453 Z",
    id: "Fill-4",
    fill: "#332E20",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.5527364,14.0614807 L21.5527364,14.0614807 L0,14 L0,24.2505483 L5.74020331,24.2672827 C4.69346888,26.5300648 4.10511071,29.0478645 4.10511071,31.6973568 L4.10511071,49 L14.3682495,49 L14.3682495,31.5922211 C14.3682495,27.6054319 17.5848489,24.3735098 21.5527364,24.3735098 C25.5206239,24.3735098 28.7372232,27.6054319 28.7372232,31.5922211 L28.7372232,49 L39,49 L39,31.5922211 C39,21.9102787 31.1887759,14.0614807 21.5527364,14.0614807",
    id: "Fill-7",
    fill: "#332E20"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMyNdw);
export default __webpack_public_path__ + "static/media/logo-my-ndw.3a7f0a5fb08d961b1ff66588d8585978.svg";
export { ForwardRef as ReactComponent };